import React, { useEffect, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import { LoginService } from '../services/LoginService'
import "./PatientCalender.css";
export const PatientAppointments = () => {
  const uid = window.sessionStorage.getItem('uid');

  const handleDateClick = (arg: any) => {
    alert(arg.dateStr)
  }
  const [calendarOptions, setCalendarOptions] = useState<any>({
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth',
    },
    editable: true,
    events: [],
    height: 800,
    aspectRatio: 1,
  });

  const getCalendarData = async () => {
    const q = 3;
    const apiname = '/ws_an_schedules.php';
    const payload = {
      userid: uid,
      q,
    };

    try {
      const res = await LoginService.getData(apiname, payload);
      console.log('Calendar events:', res);
      const formattedEvents = res.map((event: any) => ({
        ...event,
      }));

      setCalendarOptions((prevOptions: any) => ({
        ...prevOptions,
        events: formattedEvents,
      }));
    } catch (error) {
      console.error('Error fetching calendar data:', error);
    }
  };

  useEffect(() => {
    getCalendarData();
  }, [uid]);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/patientappointment.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="custom-calendar-container">
      <div className="col-16" style={{ textAlign: "right" }}>
        <a
          title="help"
          onClick={(e) => openWindow(e, IUrl)}
          style={{

            color: "blue",
            fontSize: 15, cursor: "pointer"
          }}
        >Help for this Page &nbsp;
          <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

        </a>
      </div>
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView={calendarOptions.initialView}
        headerToolbar={calendarOptions.headerToolbar}
        editable={calendarOptions.editable}
        events={calendarOptions.events}
      />
    </div>
  )
}